<template>
  <li class="faq-item py-6">
    <details :open="open" class="faq-item__details w-full" @toggle="changeOpenStatus">
      <summary class="faq-item__summary flex items-center cursor-pointer text-primary-1-100 break-words">
        <div class="font-bold text-md">
          {{ question }}
        </div>
        <svg-icon-chevron-down class="w-4 h-4 ml-auto" :class="{ 'transform rotate-180': open }" />
      </summary>
      <div class="faq-item__content text-sm text-system-gray pt-2">
        <slot></slot>
      </div>
    </details>
  </li>
</template>

<script setup lang="ts">
const props = defineProps({
  question: {
    type: String,
    required: true,
  },
  open: {
    type: Boolean,
    default: false,
  },
  index: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['toggled']);

function changeOpenStatus(e: Event) {
  const isOpen = (e.target as HTMLDetailsElement).open;
  emit('toggled', isOpen, props.index);
}
</script>

<style lang="postcss" scoped>
.faq-item {
  &:not(:last-child) {
    @apply border-b border-primary-1-15 border-opacity-50;
  }
}

.faq-item__summary::-webkit-details-marker,
.faq-item__summary::marker {
  content: '';
  display: none;
}
</style>
